import React from 'react'
import { t } from 'ttag'
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  BorderStyle,
  HeadingLevel,
} from 'docx'

const DownloadInterviewDoc = ({ sections, templateName, getButton }) => {
  const createDoc = async () => {
    const sectionHeader = text =>
      new Paragraph({
        text,
        heading: HeadingLevel.HEADING_1,
        spacing: { before: 400, after: 200 },
      })

    const introText = text =>
      new Paragraph({
        children: [
          new TextRun({
            text,
            italics: true,
            color: '555555',
          }),
        ],
        spacing: { after: 400 },
      })

    const questionCard = (number, title, lines) =>
      new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [
          new TableRow({
            children: [
              new TableCell({
                shading: { fill: 'FAFAFA' },

                margins: {
                  top: 140,
                  bottom: 100,
                  left: 160,
                  right: 140,
                },

                borders: {
                  left: {
                    style: BorderStyle.SINGLE,
                    size: 24,
                    color: '2F80ED',
                  },
                  top: {
                    style: BorderStyle.SINGLE,
                    size: 4,
                    color: 'DDDDDD',
                  },
                  bottom: {
                    style: BorderStyle.SINGLE,
                    size: 4,
                    color: 'DDDDDD',
                  },
                  right: {
                    style: BorderStyle.SINGLE,
                    size: 4,
                    color: 'DDDDDD',
                  },
                },

                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `${number}. ${title}`,
                        bold: true,
                        size: 24,
                      }),
                    ],
                    spacing: { after: 140 },
                  }),

                  ...lines.map(
                    line =>
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: line,
                            color: '444444',
                          }),
                        ],
                        spacing: { after: 90 },
                      }),
                  ),
                ],
              }),
            ],
          }),
        ],
      })

    const doc = new Document({
      styles: {
        default: {
          document: {
            run: {
              font: 'Inter',
              size: 22,
            },
          },
        },
        paragraphStyles: [
          {
            id: 'Heading1',
            name: 'Section Header',
            basedOn: 'Normal',
            next: 'Normal',
            quickFormat: true,
            run: {
              size: 32,
              bold: true,
              color: '222222',
            },
          },
        ],
      },
      sections: [
        {
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: templateName,
                  bold: true,
                  size: 38,
                }),
              ],
              spacing: { after: 150 },
            }),

            new Paragraph({
              children: [
                new TextRun({
                  text: t`Interview template`,
                  color: '666666',
                }),
              ],
              spacing: { after: 500 },
            }),

            ...sections.flatMap(({ title, questions }) => [
              sectionHeader(title),

              ...questions.map(({ title, description }, index) =>
                questionCard(
                  index + 1,
                  title,
                  description.split('- ').filter(line => line.trim() !== ''),
                ),
              ),
            ]),
          ],
        },
      ],
    })

    const blob = await Packer.toBlob(doc)
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = `${templateName}.docx`
    link.click()

    URL.revokeObjectURL(url)
  }

  return getButton(createDoc)
}

export default DownloadInterviewDoc
